module.exports = "//public.zight.com/packs/media/images/annotate/tools-zoom-zoom-out-d627e3f89a95adc8fa5b5a8912e959e0.svg";